/**
 * Language menu hover — pure CSS approach cu pseudo-element bridge.
 *
 * Bug fix din vechea implementare:
 *  - `t.classList.contains('.main-menu')` greșit → hide-uia menu la fiecare
 *    mouseover oriunde → imposibil de dat click.
 *
 *  - `.lang-menu` are `position:absolute; margin-top:-20px` care creează gap
 *    vizual între trigger și dropdown. Mouse trece prin gap → leave-uie
 *    wrapper → menu dispare → nu mai poți ajunge la el.
 *
 * Soluția: injectăm CSS la init care:
 *   1. Adaugă un pseudo-element `::after` pe `.lang-wrap` care extinde
 *      hit-area-ul wrapper-ului în jos cu 30px (bridge invisible spre menu).
 *   2. `.lang-wrap:hover .lang-menu` arată menu-ul pur CSS — fără JS timer.
 *      `:hover` rămâne activ cât timp mouse e peste wrapper SAU peste menu
 *      (CSS :hover propagă prin DOM ancestry, nu doar visual bounding box).
 *   3. `:focus-within` păstrează menu vizibil pentru navigație keyboard.
 *
 * Pure CSS = zero JS bugs, zero timing issues. Pattern standard pentru
 * dropdown-uri cu pozitionare absolute.
 */

export function initLangMenu(): void {
    // Inject one-time only
    if (document.getElementById('nav-lang-menu-style')) return;

    const style = document.createElement('style');
    style.id = 'nav-lang-menu-style';
    style.textContent = `
        .lang-wrap {
            position: relative;
        }
        /* Invisible bridge area between trigger and dropdown.
           Extends .lang-wrap's hit area downward by 30px so mouse can
           travel from trigger to dropdown without leaving :hover state. */
        .lang-wrap::after {
            content: '';
            position: absolute;
            top: 100%;
            left: -10px;
            right: -10px;
            height: 30px;
            pointer-events: auto;
        }
        /* Show dropdown on hover OR keyboard focus inside wrapper. */
        .lang-wrap:hover .lang-menu,
        .lang-wrap:focus-within .lang-menu {
            display: block !important;
        }
    `;
    document.head.appendChild(style);
}
